
export const getCountries = (state) => state.countries


